import { useParams } from 'react-router-dom';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Box, Typography } from '@mui/material';
import { DatasetSourceApiEnum } from '~/api/types';
import { useGetDatasetQuery } from '~/api/v2/hooks';
import { useGeneralDataConfig } from '~/hooks';
import { useUsersDataConfig } from '~/hooks/dataset';
import { EditIcon } from '~/icons';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';
import { detailsPageContainer, detailsPageHeaderContainer, iconButtonStyles } from '../styles';
import DatasetDetailsBlock from './DatasetDetailsBlock';

const DatasetDetailsPanel = () => {
  const datasetId = +useParams().id!;
  const dispatch = useAppDispatch();
  const { data } = useGetDatasetQuery({ datasetId });
  const { generalDataConfig } = useGeneralDataConfig();
  const { stewardsDataConfig, uploadersDataConfig } = useUsersDataConfig();
  const showEditButton =
    (data?.details_edit_allowed || data?.status_edit_allowed) &&
    ![DatasetSourceApiEnum.M2M].some((api) => api === data?.source_api);

  return (
    <>
      <Box sx={detailsPageContainer}>
        <Box sx={detailsPageHeaderContainer}>
          <Typography variant="headingS" fontWeight={600}>
            Dataset details
          </Typography>
          {showEditButton && (
            <CustomButton
              sx={iconButtonStyles}
              buttonType="borderless"
              onClick={() => dispatch(openModal({ type: ModalTypesEnum.EDIT_DATASET }))}
            >
              <EditIcon />
              Edit
            </CustomButton>
          )}
        </Box>
        <DatasetDetailsBlock dataConfig={generalDataConfig} />
        <DatasetDetailsBlock dataConfig={stewardsDataConfig} title="Data stewards" />
        <DatasetDetailsBlock dataConfig={uploadersDataConfig} title="Data uploaders" />
      </Box>
    </>
  );
};
export default DatasetDetailsPanel;
